import { FIELD_TYPES } from "../../widgets/fields";
import { CHART_TYPES } from "./utils";

export const elements = {
    sortByDropDownValues: {
        name: "sortBy",
        placeholder: "",
        label: "Sort By",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { value: "ascending", label: "Ascending Order" },
            { value: "descending", label: "Descending Order" },
        ],
        isMandatory: false,
    },
    formDropDownValues: {
        name: "formTemplate",
        placeholder: "Select Form",
        label: "Select Form",
        type: FIELD_TYPES.DROP_DOWN,
        isMandatory: false,
    },
    month: {
        name: "month",
        placeholder: "Select Month",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            {value: null, label: 'None'},
            { value: 'January', label: 'January' },
            { value: 'February', label: 'February' },
            { value: 'March', label: 'March' },
            { value: 'April', label: 'April' },
            { value: 'May', label: 'May' },
            { value: 'June', label: 'June' },
            { value: 'July', label: 'July' },
            { value: 'August', label: 'August' },
            { value: 'September', label: 'September' },
            { value: 'October', label: 'October' },
            { value: 'November', label: 'November' },
            { value: 'December', label: 'December' }
        ]
    },
    year: {
        name: "year",
        placeholder: "Select year",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { value: null, label: 'None' },
            // { value: 2010, label: '2010' },
            // { value: 2011, label: '2011' },
            // { value: 2012, label: '2012' },
            // { value: 2013, label: '2013' },
            // { value: 2014, label: '2014' },
            // { value: 2015, label: '2015' },
            { value: '2016', label: '2016' },
            { value: '2017', label: '2017' },
            { value: '2018', label: '2018' },
            { value: '2019', label: '2019' },
            { value: '2020', label: '2020' },
            { value: '2021', label: '2021' },
            { value: '2022', label: '2022' },
            { value: '2023', label: '2023' },
            { value: '2024', label: '2024' },
            { value: '2025', label: '2025' },
            // { value: 2026, label: '2026' },
            // { value: 2027, label: '2027' },
            // { value: 2028, label: '2028' },
            // { value: 2029, label: '2029' },
            // { value: 2030, label: '2030' }
        ]
    },
    district: {
        name: "district",
        placeholder: "Select District",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
    },
    designation: {
        name: "designation",
        placeholder: "Select Designation",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
    },
    startdate: {
        name: "startdate",
        placeholder: "Start Date",
        label: "Start Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: false,
    },
    enddate: {
        name: "enddate",
        placeholder: "End Date",
        label: "End Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: false,
    },
    dateScale:{
        name: "dateScale",
        placeholder: "Select Date Scale",
        label: "Date Scale",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            { value: 'day', label: 'Day' },
            { value: 'month', label: 'Month' },
            { value: 'year', label: 'Year' },
        ]
    },
    chartSelect:{
        name: "chartSelect",
        placeholder: "Select Chart",
        label: "",
        type: FIELD_TYPES.DROP_DOWN,
        values: [
            CHART_TYPES.BAR_CHART,
            CHART_TYPES.PIE_CHART
        ]
    },
    startCreatedDate: {
        name: "startCreatedDate",
        placeholder: "Start Created Date",
        label: "Start Created Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: true,
    },
    endCreatedDate: {
        name: "endCreatedDate",
        placeholder: "End Created Date",
        label: "End Created Date",
        type: FIELD_TYPES.DATE_TIME_PICKER,
        isMandatory: true,
    },
};